import { render, staticRenderFns } from "./EmpiPixList.vue?vue&type=template&id=63e53bcc&scoped=true"
import script from "./EmpiPixList.vue?vue&type=script&lang=js"
export * from "./EmpiPixList.vue?vue&type=script&lang=js"
import style0 from "./EmpiPixList.vue?vue&type=style&index=0&id=63e53bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e53bcc",
  null
  
)

export default component.exports